import { BaseRepository } from './BaseRepository';
import TestResult, { ITestResultEntity } from '../models/TestResult';
import handleResponseError from './utils/handleResponseError';

export type TestResultParams = {};

export interface ResultInfo {
  result: 'GCOVN' | 'GCOVP' | 'GCOVI' | 'GCOVX';
  result_label: string;
  tested_at: Date;
  fullname: string;
  birthdate: Date;
}

export default class TestResultRepository extends BaseRepository<any> {
  static getTestResults(): Promise<TestResult[]> {
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/covid-results`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data.map((testResultEntity: ITestResultEntity) =>
          TestResult.createFromEntity(testResultEntity)
        );
      });
  }

  static getTestResultKeyById(
    id: TestResult['id']
  ): Promise<{ key: string; expired_at: Date }> {
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/covid-results/${id}`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return {
          key: data.key,
          expired_at: new Date(data.expired_at)
        };
      });
  }

  static getTestResultPDF(testResult: TestResult) {
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(
      `${this.apiUrl}/covid-results/download/${testResult.id}`,
      requestOptions
    )
      .then((res) => res.blob())
      .then((blob) => {
        var file = window.URL.createObjectURL(blob);
        window.location.assign(file);
      });
  }

  static getTestResultInfoByKey(key: string): Promise<ResultInfo> {
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/covid-results/infos/${key}`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return {
          result: data.result,
          result_label: data.result_label,
          fullname: data.fullname,
          tested_at: new Date(data.tested_at),
          birthdate: new Date(data.birthdate)
        };
      });
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);
        return Promise.reject(error);
      }

      return res;
    });
  }
}
